import { tableHooks } from 'components/Table'
import { statuses } from 'keys'
import { affiliationCell, fileUploadedCell, useCloneAssessmentForLearningCell, useGoAssessmentCell, useTrainingAssessmentComparisonCell, useViewAssessmentCell } from '../../MarkingWords/hooks/useColumns'
import { audioCuttingByCell, audioCuttingDate, audioCuttingDurationCell, audioCuttingEndDateCell, audioCuttingStartDateCell, useBackToCuttingCell } from './useColumns'

const useTabs = () => {
    const { inProgress, backToCutting, brokenFile, wordsComplete, wordsInProgress, uploaded, backToMarking, audioCuttingComplete, audioCuttingInProgress } = statuses

    const idCell = tableHooks.useIdCell()
    const testTakerNameCell = tableHooks.useTestTakerNameCell()
    const assessmentNameCell = tableHooks.useAssessmentNameCell()
    const gradeOfAllocationCell = tableHooks.useGradeOfAllocationCell()
    const playCell = tableHooks.usePlayCell()

    // סימון מילים
    const goAssessmentCell = useGoAssessmentCell()
    const viewAssessmentCell = useViewAssessmentCell()

    const backToCuttingCell = useBackToCuttingCell()


    return [
        {
            id: 0,
            label: "ממתינים לחיתוך",
            filters: {
                status: [],
                audio_status: [],
                exclude_audio_status: [statuses.inProgress, statuses.complete],
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                gradeOfAllocationCell,
                affiliationCell,
                fileUploadedCell,
                {
                    accessorKey: 'marking_words_update_by_username',
                    header: "סימון מילים"
                },
                goAssessmentCell,
                playCell
            ],
            sortBy: {
                desc: true,
                id: "file_uploaded_date"
            }
        },
        {
            id: 1,
            label: "בחיתוך",
            filters: {
                status: [inProgress],
                audio_status: [statuses.inProgress],
                exclude_sub_status: [],
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                gradeOfAllocationCell,
                affiliationCell,
                fileUploadedCell,
                {
                    accessorKey: 'marking_words_update_by_username',
                    header: "סימון מילים"
                },
                audioCuttingStartDateCell,
                audioCuttingDate,
                audioCuttingByCell,
                viewAssessmentCell,
                playCell
            ],
            sortBy: {
                desc: true,
                id: "file_uploaded_date"
            }
        },
        {
            id: 2,
            label: "חיתוך הסתיים",
            filters: {
                status: [inProgress],
                audio_status: [statuses.complete],
                exclude_sub_status: [],
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                gradeOfAllocationCell,
                affiliationCell,
                audioCuttingByCell,
                {
                    accessorKey: 'marking_words_update_by_username',
                    header: "סימון מילים"
                },
                audioCuttingDurationCell,
                audioCuttingStartDateCell,
                audioCuttingEndDateCell,
                viewAssessmentCell,
                // backToCuttingCell,
                playCell
            ],
            sortBy: {
                desc: true,
                id: "audio_cutting_end_date"
            },
        }
    ]

}

export default useTabs
